import { createContext } from 'react';

const AutoScrollContext = createContext();

export const { Provider, Consumer } = AutoScrollContext;

export default AutoScrollContext;
